import { TicketsData } from '@/utilities/types'
import { Box, styled } from '@mui/material'
import { FC } from 'react'
import TitleTypography from '../typography/TitleTypography'
import { useMaintenanceTicketsContext } from '@/context/MaintenanceTicketsContext'

interface TicketDataProps {
  data: TicketsData
}

const BoxContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: 10,
})
const BoxContent = styled(Box)(({ theme }) => ({
  width: '50%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}))

export const TicketData: FC<TicketDataProps> = ({ data }) => {
  const { contractorQuotation } = useMaintenanceTicketsContext()
  console.log('DATA', data)

  console.log('CONTRACT QUOTATION', contractorQuotation)
  return (
    <>
      {(data.status === 'REJECTED' ||
        data.status === 'DENIED' ||
        data.status === 'FOR_REVISION' ||
        data.status === 'REVISE') && (
        <BoxContainer>
          <BoxContent>
            <TitleTypography
              title="Remarks"
              value={data.remark}
              required={false}
            />
          </BoxContent>
        </BoxContainer>
      )}
      {/**
       * Dealer & Branch Name
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Dealer Name"
            value={data.dealerName}
            required={false}
          />
        </BoxContent>
        <BoxContent>
          <TitleTypography
            title="Branch Name"
            value={data.branchName}
            required={false}
          />
        </BoxContent>
      </BoxContainer>
      {/**
       * Requestor Name & Shop Name
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Requestor Name"
            value={data.requestor}
            required={false}
          />
        </BoxContent>

        <BoxContent>
          <TitleTypography
            title="Shop Name"
            value={data.shop}
            required={false}
          />
        </BoxContent>
      </BoxContainer>
      {/**
       * Area & Province
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Area"
            value={data.areaName}
            required={false}
          />
        </BoxContent>
        <BoxContent>
          <TitleTypography
            title="Province"
            value={data.provinceName}
            required={false}
          />
        </BoxContent>
      </BoxContainer>
      {/**
       * Type of Concern & Type of Appliance/Collateral
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Type of Concern"
            value={data.typeOfConcern}
            required={false}
          />
        </BoxContent>
        <BoxContent>
          <TitleTypography
            title={`Type of ${data.typeOfConcern}`}
            value={
              data.typeOfConcernValue !== 'Others'
                ? data.typeOfConcernValue
                : data.typeOfConcernOthers
            }
            required={false}
          />
        </BoxContent>
      </BoxContainer>
      {/**
       * Purpose
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Purpose"
            value={data.purpose}
            required={false}
          />
        </BoxContent>
      </BoxContainer>
      {/**
       * Method Repair
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Method of Repair"
            value={data.methodOfRepair?.replace(/^C\/O/, 'c/o')}
            required={false}
          />
        </BoxContent>
        <BoxContent>
          <TitleTypography
            title="Cost Sharing"
            value={data.costOfSharing}
            required={false}
          />
        </BoxContent>
      </BoxContainer>
      {/**
       * Cost Amount
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Cost Amount"
            value={Number(data.amount).toFixed(3)}
            required={false}
          />
        </BoxContent>
      </BoxContainer>
      {/**
       * Remarks
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Description"
            value={data.description}
            required={false}
          />
        </BoxContent>
      </BoxContainer>
      {/**
       * Concern Attachment
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Concern Attachments"
            value={data.attachments
              ?.filter(
                ({ attachmentType }: { attachmentType: string }) =>
                  attachmentType === 'CONCERN',
              )
              .sort((a, b) => a.id - b.id)}
            required={false}
          />
        </BoxContent>
      </BoxContainer>

      {/**
       * Quotation Attachment
       */}
      <BoxContainer>
        <BoxContent>
          <TitleTypography
            title="Quotation/Certificate of Completion/Official Receipt Attachments"
            value={data.attachments
              ?.filter(({ attachmentType }: { attachmentType: string }) => {
                return (
                  attachmentType === 'CONTRACTOR_QUOTATION' ||
                  attachmentType === 'COC_QUOTATION' ||
                  attachmentType === 'QUOTATION' ||
                  attachmentType === 'PR_QUOTATION' ||
                  attachmentType === 'PO_QUOTATION'
                )
              })
              .sort((a, b) => a.id - b.id)}
            required={false}
          />
        </BoxContent>
      </BoxContainer>

      {(data.workFlowId === 1 || data.workFlowId === 2) &&
        data.currentLayerId > 3 && (
          <BoxContainer>
            <BoxContent>
              <TitleTypography
                title="Reply Letter Attachments"
                value={data.attachments?.filter(
                  ({ attachmentType }: { attachmentType: string }) => {
                    return attachmentType === 'REPLY_LETTER_QUOTATION'
                  },
                )}
                required={false}
              />
            </BoxContent>
          </BoxContainer>
        )}

      {(data.workFlowId === 4 || data.workFlowId === 5) && (
        <BoxContainer>
          <BoxContent>
            <TitleTypography
              title="DIS Attachments"
              value={data.attachments?.filter(
                ({ attachmentType }: { attachmentType: string }) => {
                  return (
                    attachmentType === 'DIS_QUOTATION' ||
                    attachmentType === 'SIGNED_DIS_QUOTATION'
                  )
                },
              )}
              required={false}
            />
          </BoxContent>
        </BoxContainer>
      )}
    </>
  )
}
